import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Popover,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, forwardRef, useRef } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Tooltip } from "@mui/material";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DateConversionOnEntryPage,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import { NavLink } from "react-router-dom";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import ReactToPrint from "react-to-print";
import {
  editDeleteCylinderInward,
  getCylinderInwardList,
} from "../../../actions/actions";
import inwardService from "../../../services/inward.Service";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import deliveryentryService from "../../../services/deliveryentry.Service";

import customerMasterService from "../../../services/masters/customerMaster.Service";
import driverMasterService from "../../../services/masters/driverMaster.Service";
import vehicleMasterService from "../../../services/masters/vehicleMaster.Service";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import salesreturnServices from "../../../services/salesreturn.services";

const ComponentToPrintWrapper = ({ quotationPrint }) => {
  const ref = useRef();
  return (
    <div style={{ display: "flex" }}>
      <ReactToPrint
        trigger={() => (
          <span style={{ display: "flex", justifyContent: "center" }}>
            <PrintOutlinedIcon />{" "}
            <span style={{ marginLeft: "22px" }}> Print Record </span>
          </span>
        )}
        content={() => ref.current}
      />
      <div style={{ display: "none" }}>
        {/* <CylinderInwardPrint ref={ref} salesOrderPrint={quotationPrint} /> */}
      </div>
    </div>
  );
};

const ListDeliveryEntry = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const totalCount = useSelector(
    (state) => state.cylinder_inward.total_count || 0
  );
  const defaultRowsPerPage = useSelector(
    (state) => state.cylinder_inward.rows_per_page || 15
  );
  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [openCylinderDialog, setOpenCylinderDialog] = useState(false);
  const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);
  const fields = ["entry_no", "entry_date", "vehicle_no","driver_name","customer_name","cylinder_count"];
  const labels = ["Entry No", "Entry Date", "Vehicle no","Driver","Customer","No Of Cylinder"];

  const [successMessage, setSuccessMessage] = useState(null);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });

  const [depotmap, setDepot] = useState({});
  const [customermap, setCustomer] = useState({});
  const [vehiclemap, setVehicle] = useState({});
  const [cylindermap, setCylinder] = useState({});
  const [drivermap, setDriver] = useState({});

  useEffect(() => {
    async function fetchMasterData() {
      try {
        const [depotData, customerData, vehicleData, cylinderData, driverData] =
          await Promise.all([
            depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
            customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
            vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
            cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
            driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
          ]);

        setDepot(Object.fromEntries(depotData.map((d) => [d.depot_id, d.depot_name])));
        setCustomer(Object.fromEntries(customerData.map((c) => [c.cust_id, c.cust_name])));
        setVehicle(Object.fromEntries(vehicleData.map((s) => [s.vehicle_id, s.vehicle_no])));
        setCylinder(Object.fromEntries(cylinderData.map((s) => [s.cylinder_id, { cylinder_no: s.cylinder_no, owner: s.owner || "TGPL" }])));
        setDriver(Object.fromEntries(driverData.map((s) => [s.driver_id, s.driver_name])));
      } catch (error) {
        console.error("Data fetching failed", error);
        setSuccessMessage("Error fetching master data");
      }
    }

    fetchMasterData();
  }, []);

  useEffect(() => {
    setController((prev) => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await salesreturnServices.getsalesreturnlist(params);
      setRows(response);
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);
    const params = {
      page: controller.page,
      size: searchValue === "" ? controller.rowsPerPage : rows[0]?.total_count || 0,
      searchKey: searchValue,
    };
    try {
      await fetchData(params);
    } catch (error) {
      console.error("Error in handleSearch:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller]);

  const deleteRecord = async (id) => {
    try {
      await deliveryentryService.editDeleteDeliveryEntry({
        entry_id: id,
        changedUpdatedValue: "delete",
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

const handleCylinderCountClick = (row) => {
  try {
    let details = row.table_details;

    // Handle cases where table_details is a string
    if (typeof details === 'string') {
      // Try parsing once
      details = JSON.parse(details);

      // If still a string, parse again (for double-stringified JSON)
      if (typeof details === 'string') {
        console.log("⚠️ Detected double stringified JSON. Parsing again...");
        details = JSON.parse(details);
      }
    }

    // Validate that details is an array
    if (!Array.isArray(details)) {
      throw new Error("Parsed table_details is not an array");
    }

    // Ensure the array is not empty
    if (details.length === 0) {
      setSuccessMessage("No cylinder details available for this entry");
      return;
    }

    console.log("✅ Parsed Cylinder Details:", details);
    setSelectedCylinderDetails(details);
    setOpenCylinderDialog(true);
  } catch (error) {
    console.error("❌ Error parsing table_details:", error);
    setSuccessMessage("Failed to load cylinder details. Please try again.");
  }
};

  const handleCloseCylinderDialog = () => {
    setOpenCylinderDialog(false);
    setSelectedCylinderDetails([]);
  };

  // Sort rows by entry_date descending
  const sortedRows = [...rows].sort(
    (a, b) => new Date(b.entry_date) - new Date(a.entry_date)
  );

  // Calculate pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


  return (
    <Box
      className={`${styles.cts_page}`}
      sx={{ padding: "0px !important", margin: "0px !important" }}
    >
      <Box className={`${styles.body}`}>
        <Breadcrumb
          routeSegments={[{ name: "Sales Retuns List" }]}
        />

        <HeaderSection
          title="SALES RETUNS LIST"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Sales Return List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        />

        <Paper sx={{ width: "100%" }}>
          <TableContainer
            component={Paper}
            className={`${styles.list_tbl_container}`}
          >
           <Table size="" stickyHeader>
  <TableHead>
    <StyledTableRow>
      <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head}>
        Entry No
      </StyledTableCell>
      <StyledTableCell align="left"  sx={{ width: '10%' }} className={styles.table_head}>
        Date
      </StyledTableCell>
      <StyledTableCell align="left"  sx={{ width: '15%' }} className={styles.table_head}>
        Vehicle No
      </StyledTableCell>
      <StyledTableCell align="left"  sx={{ width: '15%' }} className={styles.table_head}>
        Driver Name
      </StyledTableCell>
      <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head}>
        Customer Name
      </StyledTableCell>
      <StyledTableCell align="center"  sx={{ width: '15%' }}className={styles.table_head}>
        No Of Cylinder
      </StyledTableCell>
     
      <StyledTableCell align="center" className={styles.table_head}>
        Action
      </StyledTableCell>
    </StyledTableRow>
  </TableHead>

  <TableBody sx={{ backgroundColor: "#fff" }}>
    {Array.isArray(rows) &&
      sortedRows.map((row) => (
        <StyledTableRow
          key={row.entry_no}
          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
        >
          <StyledTableCell align="left" className={styles.list_table_body}>
            {row.entry_no}
          </StyledTableCell>

          <StyledTableCell align="left" className={styles.list_table_body}>
            {DateConversionOnEntryPage(row.entry_date)}
          </StyledTableCell>

          <StyledTableCell align="left" className={styles.list_table_body}>
              {row.vehicle_no}
          </StyledTableCell>

          <StyledTableCell align="left" className={styles.list_table_body}>
             {row.driver_name}
          </StyledTableCell>

          <StyledTableCell align="left" className={styles.list_table_body}>
              {row.customer_name}
          </StyledTableCell>

          <StyledTableCell align="center" className={styles.list_table_body}>
            <Tooltip title="Click here to view cylinder details" arrow>
              <span
                onClick={() => handleCylinderCountClick(row)}
                style={{ cursor: "pointer", color: "#1976d2" }}
              >
                {row.cylinderCount || "N/A"}
              </span>
            </Tooltip>
          </StyledTableCell>

          

          <StyledTableCell align="center">
            <CustomePopover
              row={row}
              handleDelete={false}
              linkTo="/storeEntries/Adddeliveryentry"
              
              showEdit={false}
                handlePrint ={false}
            />
          </StyledTableCell>
        </StyledTableRow>
      ))}
  </TableBody>
</Table>

          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={total_count || 0}
            rowsPerPage={controller.rowsPerPage}
            page={controller.page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>

<Dialog
  open={openCylinderDialog}
  onClose={handleCloseCylinderDialog}
  maxWidth="md"
  fullWidth
>
  <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    Cylinder Details ({selectedCylinderDetails.length} Cylinders)
    <IconButton
      aria-label="close"
      onClick={handleCloseCylinderDialog}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent>
    <Table size="small">
      <TableHead>
        <StyledTableRow>
          <StyledTableCell>Cylinder No</StyledTableCell>
          <StyledTableCell>Tag No</StyledTableCell>
         <StyledTableCell>Status</StyledTableCell>
          <StyledTableCell>Owner</StyledTableCell>
        </StyledTableRow>
      </TableHead>
      <TableBody>
        {selectedCylinderDetails.map((cylinder, index) => (
          <StyledTableRow key={index}>
            <StyledTableCell>{cylinder.cyl_no || "N/A"}</StyledTableCell>
            <StyledTableCell>{cylinder.tag_no || "N/A"}</StyledTableCell>
             
           
            <StyledTableCell>{cylinder.status || "N/A"}</StyledTableCell>
          
            <StyledTableCell>{cylindermap[cylinder.cyl_id]?.owner || "TGPL"}</StyledTableCell>
          </StyledTableRow>
        ))}
      </TableBody>
    </Table>
  </DialogContent>
</Dialog>


        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.entry_id || null}
          displayName={deleteInfo?.entry_id || ""}
        />
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== "clickaway") {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};
export default ListDeliveryEntry;